import n from"./use-event";const c=(t,e=()=>{})=>{n("mousedown",o=>{t.current&&(t==null?void 0:t.current)!==o.target&&!t.current.contains(o.target)&&o.clientX<document.body.scrollWidth&&e()})};var s=c;export{s as default};
//# sourceMappingURL=use-click-outside.js.map
